export default "./dist/stdassets/images/icons/info.png";